import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-center" }, "Экспорт данных завершён", -1)
const _hoisted_3 = {
  key: 0,
  class: "text-center mb-3 text-red-lighten-1"
}
const _hoisted_4 = {
  key: 1,
  class: "text-center mt-1"
}
const _hoisted_5 = {
  key: 2,
  class: "d-flex align-center justify-center"
}
const _hoisted_6 = { class: "text-center mt-1" }
const _hoisted_7 = {
  key: 3,
  class: "d-flex align-center justify-center"
}
const _hoisted_8 = { class: "text-center mt-1" }

import { ExportStatus, ImportStatus, ToolsService } from '@prodcard/core'
import { onBeforeUnmount } from 'vue'
import { ref, Ref } from 'vue'
import { callSuccessToast } from '../helpers'


export default /*#__PURE__*/_defineComponent({
  __name: 'VImportExportNotice',
  props: {
    toolsService: {}
  },
  setup(__props: any) {

const props = __props;


const showExportDialog = ref(false)
const close = ref(false)
const exportStatus: Ref<ExportStatus | undefined> = ref()
const exportStatusWatcher = props.toolsService.exportStatus.subscribe(status => {
  exportStatus.value = status
  if (status?.done) {
    showExportDialog.value = true
  } else {
    close.value = false
  }
})

const importStatus: Ref<ImportStatus | undefined> = ref()
const importStatusWatcher = props.toolsService.importStatus.subscribe(status => {
  if (!importStatus?.value?.done && status?.done) {
    callSuccessToast('Импорт завершён')
  }
  importStatus.value = status
})

const copyToClipboard = async (text: string) => {
  await navigator.clipboard.writeText(text)
}

onBeforeUnmount(() => {
  props.toolsService.exportStatus?.unsubscribe(exportStatusWatcher)
  props.toolsService.importStatus?.unsubscribe(importStatusWatcher)
})

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (exportStatus.value?.done && !close.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_v_btn, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showExportDialog.value = true))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Экспорт завершён")
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_dialog, {
      modelValue: showExportDialog.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showExportDialog).value = $event)),
      "max-width": 500,
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "pa-5 export-card bg-white" }, {
          default: _withCtx(() => [
            _hoisted_2,
            (exportStatus.value?.authCode || exportStatus.value?.importPassword)
              ? (_openBlock(), _createElementBlock("h3", _hoisted_3, " Сохраните " + _toDisplayString(exportStatus.value?.authCode && 'код регистрации') + " " + _toDisplayString(exportStatus.value?.authCode && exportStatus.value?.importPassword && 'и') + " " + _toDisplayString(exportStatus.value?.importPassword && 'пароль доступа') + " прежде чем закроете это окно! ", 1))
              : _createCommentVNode("", true),
            (exportStatus.value?.size)
              ? (_openBlock(), _createElementBlock("h4", _hoisted_4, "Размер архива: " + _toDisplayString(exportStatus.value.size), 1))
              : _createCommentVNode("", true),
            (exportStatus.value?.authCode)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("h4", _hoisted_6, "Код регистрации: " + _toDisplayString(exportStatus.value.authCode), 1),
                  _createVNode(_component_v_btn, {
                    icon: "mdi-content-copy",
                    variant: 'plain',
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (copyToClipboard(exportStatus.value?.authCode || '')))
                  })
                ]))
              : _createCommentVNode("", true),
            (exportStatus.value?.importPassword)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("h4", _hoisted_8, "Пароль доступа: " + _toDisplayString(exportStatus.value.importPassword), 1),
                  _createVNode(_component_v_btn, {
                    icon: "mdi-content-copy",
                    variant: 'plain',
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (copyToClipboard(exportStatus.value?.importPassword || '')))
                  })
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_v_card_actions, { class: "justify-end" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (showExportDialog.value = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Свернуть")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  onClick: _cache[4] || (_cache[4] = 
            () => {
              showExportDialog.value = false
              close.value = true
            }
          ),
                  variant: 'elevated'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Закрыть")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})